/**
 * Register the download component by inserting the download icon
 */
export const registerDownloadComponent = (item, el, labelButtonDownload, onDownload) => {
  const info = el.querySelector(".filepond--file-info-main");
  const downloadIcon = getDownloadIcon(labelButtonDownload);
  info.prepend(downloadIcon);
  downloadIcon.addEventListener("click", () => downloadFile(item, el, onDownload));
}

/**
* Generates the download icon
*/
export const getDownloadIcon = (labelButtonDownload) => {
  let icon = document.createElement("span");
  icon.className = "filepond--download-icon";
  icon.title = labelButtonDownload;
  return icon;
}

/**
* Triggers the actual download of the uploaded file
*/
export const downloadFile = (item, el, onDownload) => {
  try {
    onDownload(item.file)
  } catch (error) {
    console.error(error)
  }
}


// WEBPACK FOOTER //
// ./src/helpers/filepond-plugin-download-file/download.js